import NewRequest from '../components/NewRequest';
import './PermissionRequestsPage.css';
import Typography from '@mui/material/Typography';
import { Paper, useTheme } from '@mui/material';

const PermissionRequestsPage = (props: {requestsReload: number}) => {
  // const [appsWithRequests, setAppsWithRequests] = useState([]);

  // useEffect(() => {
  //   getAdminApps(props.adminId);
  // }, [])

  // const getAdminApps = async (adminId: any) => {
  //   const data =  await API.POST({"userid": adminId}, Endpoints.GetAdminApplications);
  //   setAppsWithRequests(data.applications);
  // }

  const theme = useTheme();
  return (
    <>
      <Paper 
        component={"main"} 
        className='off-white'
        sx={{backgroundColor: theme.palette.background.default}}
      >
      <nav className='sub'>
        <Typography variant="h6">
            Requests awaiting approval
            </Typography>
      </nav>
        <div className='container'><NewRequest requestsReload={props.requestsReload}/></div>
      </Paper >
    </>
  )
}

export default PermissionRequestsPage
